import { Box, Chip, Grid, TextField, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const PdfResourceSection = ({
    formik,
    allResources,
    uploadResource,
    handleDeleteResource,
    handleFormChange,
    theme
}) => (
    <Box display="flex" flexDirection="column" gap={2}>
        <Typography
            variant="subtitle2"
            sx={{
                fontWeight: 600,
                color: 'text.secondary'
            }}
        >
            Attached PDF Resources
        </Typography>

        <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Resource Title"
                    fullWidth
                    value={formik.values.resourceTitle}
                    name="resourceTitle"
                    variant="outlined"
                    placeholder="e.g. Lecture Slides, Reference Sheet"
                    onChange={(e) => {
                        const trimmedValue = e.target.value.replace(/^\s+/, '');
                        formik.handleChange(e);
                        formik.setFieldValue('resourceTitle', trimmedValue);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Box
                    sx={{
                        border: '2px dashed',
                        borderColor: theme.palette.divider,
                        borderRadius: '12px',
                        p: 2,
                        textAlign: 'center',
                        backgroundColor: theme.palette.grey[50],
                        position: 'relative',
                        cursor: 'pointer',
                        height: '56px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            borderColor: theme.palette.secondary.main,
                            backgroundColor: 'rgba(82, 146, 221, 0.04)'
                        }
                    }}
                >
                    <input
                        type="file"
                        accept="application/pdf"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                        onChange={uploadResource}
                    />
                    <Box display="flex" alignItems="center" gap={1}>
                        <PictureAsPdfIcon
                            sx={{
                                color: theme.palette.text.secondary
                            }}
                        />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Choose PDF Resource file
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>

        {allResources?.length > 0 && (
            <Box sx={{ mt: 1 }}>
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 700,
                        color: 'text.secondary',
                        display: 'block',
                        mb: 1
                    }}
                >
                    Uploaded Attachments ({allResources.length} of 3)
                </Typography>
                <Box display="flex" flexWrap="wrap" gap={1.5}>
                    {allResources.map((resource, index) => (
                        <Chip
                            key={resource?._id || index}
                            icon={<PictureAsPdfIcon />}
                            label={
                                resource?.name ||
                                resource?.resourseFile?.split('resource-').pop()
                            }
                            onDelete={() => handleDeleteResource(resource?._id)}
                            color="secondary"
                            variant="outlined"
                            sx={{
                                py: 2,
                                px: 1,
                                borderRadius: '8px',
                                fontWeight: 500
                            }}
                        />
                    ))}
                </Box>
            </Box>
        )}
    </Box>
);

export default PdfResourceSection;
